import { render, staticRenderFns } from "./RidingInterest.vue?vue&type=template&id=0b874027&scoped=true&"
import script from "./RidingInterest.vue?vue&type=script&lang=js&"
export * from "./RidingInterest.vue?vue&type=script&lang=js&"
import style0 from "./RidingInterest.vue?vue&type=style&index=0&id=0b874027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b874027",
  null
  
)

export default component.exports